import { componentLoader } from "banco-website/Common/components";
import { V3LoanCalculator } from "banco-components/index";

// Props are always empty - previously set via an inline <script nonce="..."> rendered by
// _loan_calculator_v3.html.erb, but that partial can be cached (e.g. Prismic page caching),
// baking in a stale nonce that no longer matches the CSP header and gets the script blocked.
window.fb.loan_calculator_v3_props = window.btoa(JSON.stringify({}));

componentLoader({
  component: V3LoanCalculator,
  propsKey: "loan_calculator_v3_props",
  hookDivId: "loan_calculator_v3"
});
